module.exports = __webpack_public_path__ + "static/media/bygga.ab6e6380.mp3";